/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { connect } from 'react-redux';
import { sortingProperties as sortingPropertiesSelector } from '@Containers/SortingProperties/SortingPropertiesSelectors';
import { fetchSortingProperties as fetchSortingPropertiesAction } from '@Containers/SortingProperties/SortingPropertiesActions';
import { substances } from '@Constants';
import { eachHierarchy } from '../../../Hooks/LibraryInitialization/MoreUnderscore';

export const findSimilarityMollFromBreadcrumb = (activeBreadcrumb) => {
  if (!activeBreadcrumb || activeBreadcrumb.context !== substances) return null;
  const { structure } = activeBreadcrumb; // quick search structure
  if (!structure && activeBreadcrumb.queryFactItem && activeBreadcrumb.queryFactItem.facts) {
    try {
      const { facts } = activeBreadcrumb.queryFactItem;
      // dfs traverse of facts tree
      let structures = [];
      eachHierarchy(
        facts,
        (fact) => {
          if (fact && fact.structures) {
            structures = structures.concat(fact.structures.map((s) => s.structure));
          }
        },
        null,
        { children: 'facts' }
      );
      if (structures.length > 1) return null;
      if (structures.length === 1) return structures[0];
    } catch (e) {
      Logger.error("Can't get similarity moll structure from breadcrumbs", e);
    }
  }
  return structure;
};

const withSortingProperties = () => (Component) => {
  function WithSortingPropertiesHOC({ sortingProperties, fetchSortingProperties, ...otherProps }) {
    useEffect(() => {
      if (!sortingProperties) {
        const { activeBreadcrumb } = otherProps;
        const similarityMol = findSimilarityMollFromBreadcrumb(activeBreadcrumb);
        fetchSortingProperties(similarityMol);
      }
    }, [sortingProperties, otherProps?.params]);

    return <Component {...otherProps} sortingProperties={sortingProperties} />;
  }

  WithSortingPropertiesHOC.propTypes = {
    sortingProperties: PropTypes.instanceOf(List),
    fetchSortingProperties: PropTypes.func.isRequired,
  };

  const mapStateToProps = (state) => ({
    sortingProperties: sortingPropertiesSelector(state),
  });

  const mapDispatchToProps = {
    fetchSortingProperties: fetchSortingPropertiesAction,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithSortingPropertiesHOC);
};

export default withSortingProperties;
